import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { InsightsService } from './services/insights.service';

@NgModule({
	providers: [
		InsightsService,
		provideAppInitializer(() => {
			const dataInsightsService = inject(InsightsService);
			dataInsightsService.init();
		})
	]
})
export class InsightsModule {}
